<div>
  <div class="months">
    <div></div>
    @for (month of [5, 4, 3, 2, 1, 0]; track month) {
      <div class="month">
        <span>{{ getMonth(month) }}</span>
        <mat-icon color="primary" [matTooltip]="'DEBTS.delivered' | translate">archive</mat-icon>
      </div>
    }
  </div>

  @if (!oneProject) {
    @for (project of (projects$ | async); track trackById($index, project)) {
      <app-debts-row
        [project]="project"
        [debt]="summary[project.id]">
      </app-debts-row>
    }
  } @else {
    @if (currentProject$ | async; as project) {
      <app-debts-row
        [oneProject]="true"
        [project]="project"
        [debt]="debts[0]">
      </app-debts-row>
    }
  }

</div>
